import { render } from "./CustomerLayoutWithNav.vue?vue&type=template&id=5a7622ba&scoped=true&ts=true&lang=pug"
import script from "./CustomerLayoutWithNav.vue?vue&type=script&lang=ts&setup=true"
export * from "./CustomerLayoutWithNav.vue?vue&type=script&lang=ts&setup=true"

import "./CustomerLayoutWithNav.vue?vue&type=style&index=0&id=5a7622ba&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a7622ba"]])

export default __exports__